export default __webpack_public_path__ + "static/media/laptop_gears.915ddec5.svg";